<!--
  File name: NotificationsDialog.vue
  Program Description:
    - This component is the modal used by the In-App notifications.
    - When accessed, it renders the new notifications available only to the user.
  Includes:
    * Notification list
-->
<template>
  <v-container>
    <v-dialog
      v-model="showNotificationsDialog"
      max-width="600px"
      overlay-opacity="0"
      scrollable
    >
      <NotificationsList
        :notifications="notifications"
        @checkNotifications="checkNotifications"
        @navigateToNotification="navigateToNotification"
        @fetchNotifications="fetchNotifications"
      />
    </v-dialog>
  </v-container>
</template>

<script>

import NotificationsList from '@/components/notifications/NotificationsList'
import { socket } from '@/socket'
import { mapGetters } from 'vuex'
export default {
  name: 'NotificationsDialog',
  components: {
    NotificationsList
  },
  props: {
    value: Boolean
  },
  data: () => ({
    users: []
  }),
  computed: {
    ...mapGetters('notifications', {
      notifications: 'getNotificationValues',
      navigateToCommentTab: 'getNavigateToCommentTab'
    }),
    showNotificationsDialog: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  beforeCreate () {
    socket.on('connect', () => {
      this.users.forEach((user) => {
        if (user.self) {
          user.connected = true
        }
      })
    })
    socket.on('disconnect', () => {
      this.users.forEach((user) => {
        if (user.self) {
          user.connected = false
        }
      })
    })
  },
  created () {
  },
  methods: {
    // Navigates to notifications page
    async checkNotifications () {
      this.$emit('input', false)
      await this.$router.push({
        name: 'notifications'
      })
    },
    // Navigates to the selected notification route
    async navigateToNotification (value) {
      socket.emit('update notifications', value._id)
      this.$store.dispatch('notifications/updateNotification', { notificationId: value._id })
      this.notificationsCount()

      const params = {
        operation: 'view',
        id: value.collectionId
      }
      if (value.collectionName === 'DataBreachView') {
        params.dataTab = 'pdbnf'
      }

      await this.$router.push({
        name: value.collectionName,
        params
      })
      this.$emit('input', false)
    },
    // fetch for the user notification
    fetchNotifications () {
      socket.emit('fetch notifications')
    },
    // returns the number of new notifications
    notificationsCount () {
      this.$emit('notificationsCount', this.notifications)
    }
  }
}
</script>

<style scoped>
.v-dialog__content {
  align-items: flex-start;
  justify-content: flex-end;
  padding-top: 30px;
  padding-left: 350px;
}

</style>
